//import _system = require('durandal/system');
import { ToastrService } from 'ngx-toastr';

function logIt(message: string, data: Object, source: string, showToast: boolean, toastType: string, toastr: ToastrService) {
    source = source ? '[' + source + '] ' : '';
    if (data) {
        //_system.log(source, message, data);
    } else {
        //_system.log(source, message);
    }
    if (showToast) {
        if (toastType === 'error') {
            toastr.error(message);
        } else { 
            toastr.info(message);
        }
    }
}

export function log(message: string, data: Object, source: string, showToast: boolean, toastr: ToastrService) {
    logIt(message, data, source, showToast, 'info', toastr);
}

export function logError(message: string, data: Object, source: string, showToast: boolean, toastr: ToastrService) {
    logIt(message, data, source, showToast, 'error', toastr);
}
